import React, { useCallback, useState } from 'react'
import BaseInputs from '@/components/codeLists/baseInputs'
import * as PropTypes from 'prop-types'
import CompanyClassInputs from '@/components/codeLists/companyClassInput'

const CompanyClassItemForm = function CompanyClassItemForm (props) {
  const [formValues, setFormValues] = useState({
    id: props.item.id || undefined,
    name: props.item.name || '',
    latinName: props.item.latinName || '',
    code: props.item.code || '',
    legacyCode: props.item.legacyCode || undefined,
    minimumInstitutions: props.item.minimumInstitutions || 0,
    validFrom: props.item.validFrom || ''
  })

  const handleBaseInputsChange = useCallback((values) => {
    setFormValues(prevValues => {
      const newValues = {
        ...prevValues,
        ...values
      }
      props.onChange(newValues)
      return newValues
    })
  }, [props])

  const handleCompanyClassInputsChange = useCallback((value) => {
    setFormValues(prevValues => {
      const newValues = {
        ...prevValues,
        minimumInstitutions: value
      }
      props.onChange(newValues)
      return newValues
    })
  }, [props])

  return (
    <div>
      <BaseInputs
        name={formValues.name}
        latinName={formValues.latinName}
        code={formValues.code}
        legacyCode={formValues.legacyCode}
        isReadOnly={props.isReadOnly}
        onChange={handleBaseInputsChange}
      />
      <CompanyClassInputs
        value={formValues.minimumInstitutions}
        isReadOnly={props.isReadOnly}
        onChange={handleCompanyClassInputsChange}
      />
    </div>
  )
}

CompanyClassItemForm.propTypes = {
  item: PropTypes.object,
  isReadOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

export default CompanyClassItemForm



// WEBPACK FOOTER //
// ./src/components/codeLists/companyClassItemForm.js